// extracted by mini-css-extract-plugin
module.exports = {"link":"GoldenLinks_link__qbA6q","text":"GoldenLinks_text__CvaCj"};